import { CheckRectangle } from "../atoms/checkbox"
import { StandardButton } from "../atoms/buttons";
import { useState, useEffect, useRef } from "react";
import { InputForm } from "../atoms/input";

export const MultipleOptions = ({ data, updateAnswer }) => {
    const [answerOptions, setAnswerOptions] = useState([
        { quiz_correct_answer: false, quiz_answer: "", id: 1 },

        { quiz_correct_answer: false, quiz_answer: "", id: 2 },

        { quiz_correct_answer: false, quiz_answer: "", id: 3 }]);
    const [quizQuestion, setQuizQuestion] = useState("")
    const [allowAnswerDeletion, setAllowAnswerDeletion] = useState(false);
    const newId = useRef(3);
    useEffect(() => {
        if (data?.quiz_answers) {
            setAnswerOptions(data.quiz_answers)
            setQuizQuestion(data.quiz_question)
        }
    }, [data])
    function checkAnswerDeletions(newAnswerOptions) {
        newAnswerOptions.length < 4 ? setAllowAnswerDeletion(false) : setAllowAnswerDeletion(true);
    }

    function changeAnswerText(index, text) {
        let newAnswerOptions = [...answerOptions];
        newAnswerOptions[index] = { "quiz_correct_answer": answerOptions[index].quiz_correct_answer, "quiz_answer": text, "id": answerOptions[index].id };
        setAnswerOptions(newAnswerOptions);
        const completeContent = {"quiz_question":quizQuestion, "quiz_answer_content":newAnswerOptions}
        updateAnswer(completeContent)
    }
    function changeQuestionTitle(text){
        setQuizQuestion(text)
        const completeContent = {"quiz_question":text, "quiz_answer_content":[...answerOptions]}
        updateAnswer(completeContent)
    }
    function addAnswerOption() {
        newId.current++;
        let newAnswerOptions = [...answerOptions, { "quiz_correct_answer": false, "quiz_answer": "", "id": newId.current }]
        setAnswerOptions(newAnswerOptions);
        checkAnswerDeletions(newAnswerOptions)
        const completeContent = {"quiz_question":quizQuestion, "quiz_answer_content":newAnswerOptions}
        updateAnswer(completeContent)
        
    }

    function removeAnswerOption(index) {
        let newAnswerOptions = [...answerOptions];
        newAnswerOptions.splice(index, 1);
        setAnswerOptions(newAnswerOptions);
        checkAnswerDeletions(newAnswerOptions)
        updateAnswer(newAnswerOptions)
    }

    function changeAnswerCorrectness(index) {
        let newAnswerOptions = [...answerOptions];
        newAnswerOptions[index] = { "quiz_correct_answer": !answerOptions[index].quiz_correct_answer, "quiz_answer": answerOptions[index].quiz_answer, "id": answerOptions[index].id };
        setAnswerOptions(newAnswerOptions);
        const completeContent = {"quiz_question":quizQuestion, "quiz_answer_content":[...newAnswerOptions]}
        updateAnswer(completeContent)
        
    }

    return (
        <>
            <div style={{ height: "auto" }} className={"vertical"}>
                <InputForm
                     title={"Quiz vraag:"}
                      value={quizQuestion} 
                      placeholder={"Voeg hier uw vraag in"}
                      typeInput={(newText) => changeQuestionTitle(newText)}
                      />
                {
                    answerOptions.map((option, index) => {
                        return (
                            <CheckRectangle
                                key={option.id}
                                textValue={option.quiz_answer}
                                CorrectValue={option.quiz_correct_answer}
                                allowAnswerDeletion={allowAnswerDeletion}
                                HandleRemoveOption={() => removeAnswerOption(index)}
                                handleTextChange={(text) => changeAnswerText(index, text)}
                                handleCorrectChange={(value) => changeAnswerCorrectness(index, value)}
                            />
                        )
                    })
                }
                <StandardButton style={{ marginLeft: "0" }} title={"Nieuwe antwoordmogelijkheid"} onClick={() => addAnswerOption()} />
            </div>
        </>
    )
}